import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ConnectedGlyph = /*#__PURE__*/createElement("g", {
  id: "connected"
}, /*#__PURE__*/createElement("path", {
  d: "M42,69.79A27.79,27.79,0,1,1,69.79,42,27.83,27.83,0,0,1,42,69.79Zm0-53.58A25.79,25.79,0,1,0,67.79,42,25.82,25.82,0,0,0,42,16.21Z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,21.75A20.25,20.25,0,1,0,62.25,42,20.27,20.27,0,0,0,42,21.75Z"
}));
const Connected = createSvg({
  name: 'connected',
  path: ConnectedGlyph
});

export default Connected;
export { ConnectedGlyph };
